import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SiteFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200 mt-20 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 group">
              <div className="relative w-9 h-9 rounded-full bg-[#E11D48] flex items-center justify-center shadow-sm overflow-hidden">
                <div className="absolute top-0 left-0 right-0 h-1/2 bg-[#E11D48]" />
                <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-white" />
                <div className="absolute top-1/2 left-0 right-0 h-[3px] bg-slate-900 -translate-y-1/2" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-white border-[3px] border-slate-900" />
              </div>
              <span className="font-heading font-extrabold text-lg tracking-tight text-slate-900">
                Cartonomie
              </span>
            </Link>
            <p className="text-xs text-slate-500 mt-3 max-w-xs leading-relaxed">
              {t(
                "footer.about_text",
                "L'index mondial communautaire des prix de cartes Pokémon. Toutes les langues, toutes les séries, des prix réels de marché."
              )}
            </p>
            <p className="text-[10px] text-slate-400 mt-4 tracking-wider">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Navigate */}
          <div>
            <h4 className="font-heading font-bold text-xs uppercase tracking-wider text-slate-900 mb-3">
              {t("footer.col_explore", "Explorer")}
            </h4>
            <ul className="space-y-2 text-xs text-slate-600">
              <li><Link to="/sets" className="hover:text-[#E11D48] transition" data-testid="footer-link-sets">{t("nav.sets")}</Link></li>
              <li><Link to="/search" className="hover:text-[#E11D48] transition" data-testid="footer-link-cards">{t("nav.cards")}</Link></li>
              <li><Link to="/rankings" className="hover:text-[#E11D48] transition" data-testid="footer-link-rankings">{t("nav.rankings")}</Link></li>
              <li><Link to="/index" className="hover:text-[#E11D48] transition" data-testid="footer-link-index">Index</Link></li>
              <li><Link to="/feed" className="hover:text-[#E11D48] transition" data-testid="footer-link-feed">{t("nav.feed", "Communauté")}</Link></li>
              <li><Link to="/sponsors" className="hover:text-[#E11D48] transition" data-testid="footer-link-sponsors">Annonces</Link></li>
            </ul>
          </div>

          {/* Company / Legal */}
          <div>
            <h4 className="font-heading font-bold text-xs uppercase tracking-wider text-slate-900 mb-3">
              {t("footer.col_company", "Cartonomie")}
            </h4>
            <ul className="space-y-2 text-xs text-slate-600">
              <li><Link to="/about" className="hover:text-[#E11D48] transition" data-testid="footer-link-about">{t("footer.about", "À propos")}</Link></li>
              <li><Link to="/contact" className="hover:text-[#E11D48] transition" data-testid="footer-link-contact">{t("footer.contact", "Contact")}</Link></li>
              <li><Link to="/legal" className="hover:text-[#E11D48] transition" data-testid="footer-link-legal">{t("footer.legal_notice", "Mentions légales")}</Link></li>
              <li><Link to="/privacy" className="hover:text-[#E11D48] transition" data-testid="footer-link-privacy">{t("footer.privacy", "Confidentialité")}</Link></li>
              <li><Link to="/terms" className="hover:text-[#E11D48] transition" data-testid="footer-link-terms">{t("footer.terms", "CGU")}</Link></li>
              <li><Link to="/cookies" className="hover:text-[#E11D48] transition" data-testid="footer-link-cookies">{t("footer.cookies", "Cookies")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-100 mt-8 pt-6 flex flex-wrap items-center justify-between gap-3 text-[11px] text-slate-400">
          <span>© {year} Cartonomie. {t("footer.rights", "Tous droits réservés.")}</span>
          <span>{t("footer.credit")}</span>
        </div>
        <p className="text-[10px] text-slate-400 mt-3 leading-relaxed">
          {t(
            "footer.disclaimer",
            "Cartonomie est un projet indépendant non affilié à Nintendo, Game Freak, Creatures Inc., The Pokémon Company ou Wizards of the Coast. Pokémon et tous les noms associés sont des marques de leurs propriétaires respectifs."
          )}
        </p>
      </div>
    </footer>
  );
}
